import React from 'react';
import PropTypes from 'prop-types';
import DocumentRow from "../../DocumentRow";
import {I18nUtils} from "../../../../../i18n/I18nUtils";
import DocumentState from "../../DocumentState";
import DateFormatter from "../../../utils/DateFormatter";
import Arrays from "../../../utils/Arrays";

export default class DocumentTabRow extends React.Component {

  static renderHead(id, showCheck = false, checked = false, onChecked = (checked) => {}) {
    return (
      <tr>
        {showCheck ?
          <th className="check-export-delete">
            <input
              type="checkbox"
              id={'document-tab-row-header-' + id}
              className="filled-in chk-col-blue-grey"
              checked={checked}
              onChange={({target}) => onChecked(target.checked)}
            />
            <label htmlFor={'document-tab-row-header-' + id}><strong>{I18nUtils.tr('TR_EXPORTAR_TODO')}</strong></label>
          </th>
          : null}
        <th>{I18nUtils.tr('TR_ESTADO')}</th>
        <th>{I18nUtils.tr('TR_NOMBRE_DOCUMENTO')}</th>
        <th>{I18nUtils.tr('TR_FECHA_DOCUMENTO')}</th>
        <th>{I18nUtils.tr('TR_CADUCIDAD')}</th>
      </tr>
    );
  }

  constructor(init){
    super(init);
    this.handleChange = this.handleChange.bind(this);
  }

  handleChange({target}){
    this.props.actionSelectItem(this.props.document, target.checked);
  }

  render() {
    const {document} = this.props;
    const expirationDateString = DateFormatter.formatDate(document.end_date);

    return (
      <tr>
        {this.props.selectedIds !== null ?
          <td className="check-export-delete">
            <input
              type="checkbox"
              id={'check-document-tab-' + this.props.id + '-' + document.id}
              className="filled-in chk-col-blue-grey"
              onChange={this.handleChange}
              checked={Arrays.contains(this.props.selectedIds, this.props.document.id)}
            />
            <label htmlFor={'check-document-tab-' + this.props.id + '-' + document.id}>{I18nUtils.tr('TR_EXPORTAR')}</label>
          </td>
          : null}
        <td><DocumentState state={document.document_state}/></td>
        {DocumentRow.renderTdDocumentName(document)}
        <td>{DateFormatter.formatDate(document.start_date)}</td>
        <td>{expirationDateString ? expirationDateString : 'N/A'}</td>
      </tr>
    );
  }

}

DocumentTabRow.propTypes = {
  id: PropTypes.string.isRequired,
  document: PropTypes.objectOf(PropTypes.any).isRequired,

  selectedIds: PropTypes.array,
  actionSelectItem: PropTypes.func,
};

DocumentTabRow.defaultProps = {
  selectedIds: null,
  actionSelectItem: () => {},
};



// WEBPACK FOOTER //
// ./src/app/shared/components/tabs/documents/DocumentTabRow.js